import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";
import 'lib-flexible/flexible.js'
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';


Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.axios = axios

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
